import { serviceMaker, methods, api } from "@/http/index.js";

export const getsalescataloge = () =>
  serviceMaker(`/salescataloge`, methods.GET, api.NGB);
export const getusercataloge = () =>
  serviceMaker(`/usercataloge`, methods.GET, api.NGB);
export const viewSalesCataloge = (id) =>
  serviceMaker(`/salescataloge/${id}`, methods.GET, api.NGB);
export const viewUserCataloge = (id) =>
  serviceMaker(`/usercataloge/cataloge/${id}`, methods.GET, api.NGB);
export const editViewSAlesCataloge = (id) =>
  serviceMaker(`/salescataloge/${id}?template=true`, methods.GET, api.NGB);
export const updateSalesCataloge = (id, data) =>
  serviceMaker(`/salescataloge/${id}`, methods.PUT, api.NGB, data);
export const editViewUserCataloge = (id) =>
  serviceMaker(`/usercataloge/${id}?template=true`, methods.GET, api.NGB);
export const updateUserCataloge = (id, data) =>
  serviceMaker(`/usercataloge/${id}`, methods.PUT, api.NGB, data);
export const getSalesCatalogeMappingTemplate = () =>
  serviceMaker(`/salescatalogemapping/template`, methods.GET, api.NGB);
export const getUserCatalogeMappingTemplate = () =>
  serviceMaker(`/usercataloge/template`, methods.GET, api.NGB);
export const createsalescataloge = (data) =>
  serviceMaker(`/salescataloge`, methods.POST, api.NGB, data);
export const createUsercataloge = (data) =>
  serviceMaker(`/usercataloge`, methods.POST, api.NGB, data);
export const deletesalescataloge = (id) =>
  serviceMaker(`/salescataloge/${id}`, methods.DELETE, api.NGB);
